import { ApiClientAxios, apiFactoryConfig, SetAmlIdentificationRequest } from "@repo/api";
import { useMutation, UseMutationOptions } from "@tanstack/react-query";

export type setDPSAmlIdentificationVariables = {
    contractId: string;
    setAmlIdentificationRequest: SetAmlIdentificationRequest;
};

export const useSetDPSAmlIdentificationMutation = (
    options?: Partial<UseMutationOptions<void, Error, setDPSAmlIdentificationVariables>>,
) => {
    const api = ApiClientAxios.ContractsDpsApiFactory(...apiFactoryConfig);
    return useMutation<void, Error, setDPSAmlIdentificationVariables>({
        mutationFn: async ({ contractId, setAmlIdentificationRequest }: setDPSAmlIdentificationVariables) => {
            await api.setDPSAmlIdentificationPut(contractId, setAmlIdentificationRequest);
        },
        ...options,
    });
};
